import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/service/notification.service';
import { finalize } from 'rxjs/operators';
import { FormHelper } from '../../shared/mixin/form-helper';
import { AccountManagerService } from '../account-manager.service';

@Component({
  selector: 'app-create-account-manager-form',
  templateUrl: './create-account-manager-form.component.html',
  styleUrls: ['./create-account-manager-form.component.scss']
})
export class CreateAccountManagerFormComponent extends FormHelper() implements OnInit {

  public form!: UntypedFormGroup;
  public isSaving: boolean = false;

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private accountManagerService: AccountManagerService,
    private notificationService: NotificationService
  ) {
    super();
  }

  ngOnInit() {
    this.form = this.createForm();
  }

  public onSubmit(): void {
    this.form.markAllAsTouched();

    if (!this.form.valid) {
      return;
    }

    this.isSaving = true;

    this.accountManagerService
      .create(this.form.value)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.notificationService.success_ts('account_manager.created');
          this.router.navigateByUrl('/account-managers');
        }
      });
  }

  private createForm() {
    return this.fb.group({
      name: this.fb.control('', Validators.required),
      accountManagerId: this.fb.control('', Validators.required),
    });
  }
}
